import styled, { css, DefaultTheme } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { Button } from '@/components/UI/Button/Button';
import { VariantType } from '@/components/Ad/Status/PaymentFlow.types';

const variantColors = (theme: DefaultTheme): Record<VariantType, string> => ({
  bundle: theme.palette.secondary.background,
  vip: theme.palette.brand.vip2,
  featured: theme.palette.brand.premium2,
});

export const Box = styled.div`
  background-color: ${({ theme }) => theme.palette.system.white};
  padding: 0 15px 15px;
  height: 100%;
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '0',
}))`
  text-align: center;
`;

export const Subtitle = styled(Typography.Body)`
  text-align: center;
  margin: 20px 0;
`;

export const Variant = styled(Checkbox)<{
  $isActive: boolean;
  $type: VariantType;
}>`
  justify-content: initial;
  gap: 15px;
  padding: 15px;
  height: 80px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background-color: ${({ theme, $isActive, $type }) =>
    $isActive ? variantColors(theme)[$type] : theme.palette.primary.background};
  margin-bottom: 10px;
  transition: background-color 0.3s ease-in-out;
`;

export const VariantIconBox = styled.div`
  flex: 0 0 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const VariantTexts = styled.div`
  flex-grow: 1;
  display: grid;
  gap: 5px;
`;

export const VariantTitle = styled(Typography.Header)<{ $isWhite: boolean }>`
  ${({ $isWhite }) =>
    $isWhite &&
    css`
      color: ${({ theme }) => theme.palette.system.white};
    `}
`;

export const VariantPrice = styled(Typography.Body)<{ $isWhite: boolean }>`
  ${({ $isWhite }) =>
    $isWhite &&
    css`
      color: ${({ theme }) => theme.palette.system.white};
    `}
`;

export const ContinueButton = styled(Button)`
  margin-top: 20px;
  margin-bottom: 25px;
  font-weight: 500;
`;

export const NeedMoreInfo = styled(Typography.Body).attrs({
  $variant: '3',
})`
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.labels};

  a {
    color: ${({ theme }) => theme.palette.system.blue};
    text-decoration: underline;
  }
`;

export const MultiplePrices = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
